var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FrameApi',{attrs:{"endpoint":_vm.endpoint},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var articles = ref.data;
var meta = ref.meta;
var fetchList = ref.methods.query;
return [_c('FrameHooks',{on:{"created":function($event){return fetchList({
      filter: { category: _vm.$route.query.filter },
      page: _vm.$route.query.page,
    })},"route-query-change":function($event){return fetchList({
      filter: { category: $event.filter },
      page: $event.page,
    })}}},[_c('ListingLayout',{attrs:{"data-qa":"article listing"}},[_c('NavFilter',{attrs:{"slot":"filter","filters":_vm.filters},slot:"filter"}),_c('ArticleGrid',{attrs:{"slot":"grid","articles":articles},slot:"grid"}),_c('NavPagination',{attrs:{"slot":"pagination","route-query":_vm.$route.query,"page-count":meta ? meta.pageCount : 0},slot:"pagination"})],1)],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }